<template>
    <div class="ai-summary-card">
        <div class="ai-summary-card__header">
            <CompassObject :object="icon" size="small" />
            <h3 class="ai-summary-card__title typographies/heading/h3">{{ titles[type] }}</h3>
        </div>
        <div class="ai-summary-card__content typographies-paragraph-medium-regular">
            <component :is="componentToDisplay" />
        </div>
    </div>
</template>
<script>
const TYPE = Object.freeze({
    CLIENT: 'client',
    DOCUMENT: 'document',
    SALES: 'sales',
    INTERACTIONS: 'interactions',
    RECOMMENDATIONS: 'recommendations',
});

import AIClientContent from 'vcomponents/AISummary/Content/AIClientContent.vue';
import AIDocumentContent from 'vcomponents/AISummary/Content/AIDocumentContent.vue';
import AISalesContent from 'vcomponents/AISummary/Content/AISalesContent.vue';
import AIInteractionsContent from 'vcomponents/AISummary/Content/AIInteractionsContent.vue';
import AIRecommendationsContent from 'vcomponents/AISummary/Content/AIRecommendationsContent.vue';

export default {
    props: {
        type: {
            type: String,
            required: true,
            validator: (value) => Object.values(TYPE).includes(value),
        },
    },
    data() {
        return {
            titles: {
                client: this.$t.__('overview.tabs.TabSummary.card.title.client'),
                document: this.$t.__('overview.tabs.TabSummary.card.title.document'),
                sales: this.$t.__('overview.tabs.TabSummary.card.title.sales'),
                interactions: this.$t.__('overview.tabs.TabSummary.card.title.interactions'),
                recommendations: this.$t.__('overview.tabs.TabSummary.card.title.recommendations'),
            },
        };
    },
    computed: {
        icon() {
            switch (this.type) {
                case TYPE.CLIENT:
                    return 'contact';
                case TYPE.DOCUMENT:
                    return 'document';
                case TYPE.SALES:
                    return 'payment';
                case TYPE.INTERACTIONS:
                    return 'interaction';
                default:
                    return 'insight';
            }
        },
        componentToDisplay() {
            switch (this.type) {
                case TYPE.CLIENT:
                    return AIClientContent;
                case TYPE.DOCUMENT:
                    return AIDocumentContent;
                case TYPE.SALES:
                    return AISalesContent;
                case TYPE.INTERACTIONS:
                    return AIInteractionsContent;
                case TYPE.RECOMMENDATIONS:
                    return AIRecommendationsContent;
                default:
                    return AIClientContent;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-summary-card {
    background: var(--colors-common-background-default);
    border-radius: var(--spacing-4);
    padding: var(--spacing-4);

    &__header {
        align-items: center;
        display: flex;
        gap: var(--spacing-3);
        margin: 0 0 var(--spacing-3);
    }

    &__title {
        margin: 0;
    }
}
</style>
